/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./components');

/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Piramal = {
        // All pages
        'common': {
            init: function() {
                // JavaScript to be fired on all pages
                document.documentElement.className += "js";

                /**
                 *
                 * Typekit
                 *
                 */
                (function(d) {
                    var config = {
                            kitId: 'ubj3und',
                            scriptTimeout: 3000,
                            async: true
                        },
                        h = d.documentElement,
                        t = setTimeout(function() { h.className = h.className.replace(/\bwf-loading\b/g, "") + " wf-inactive"; }, config.scriptTimeout),
                        tk = d.createElement("script"),
                        f = false,
                        s = d.getElementsByTagName("script")[0],
                        a;
                    h.className += " wf-loading";
                    tk.src = 'https://use.typekit.net/' + config.kitId + '.js';
                    tk.async = true;
                    tk.onload = tk.onreadystatechange = function() { a = this.readyState; if (f || a && a != "complete" && a != "loaded") return;
                        f = true;
                        clearTimeout(t); try { Typekit.load(config) } catch (e) {} };
                    s.parentNode.insertBefore(tk, s)
                })(document);


                /**
                 *
                 * Location Nav
                 *
                 */
                $('.locations-toggle, .location-selector button.close').on('click', function() {
                    $('body').toggleClass('fixed-hidden');
                    $('.locations-menu-container').toggleClass('active');
                });
            


                /**
                 *
                 * Google Fonts
                 *
                 */
                WebFontConfig = {
                    google: { families: [ 
                        'Source+Sans+Pro:300,400,400italic,600,600italic,700,700italic:latin',
                        'Ubuntu:500,700'
                    ] }
                };
                (function() {
                    var wf = document.createElement('script');
                    wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1/webfont.js';
                    wf.type = 'text/javascript';
                    wf.async = 'false';
                    var s = document.getElementsByTagName('script')[0];
                    s.parentNode.insertBefore(wf, s);
                })();

                

                /**
                 *
                 * Responsive iframe container
                 *
                 */
                $(document).ready(function() {
                    // maybe change this to .responsive-iframe class
                    $('.responsive-iframe').wrap('<div class="video-container"/>');

                    // Youtube videos
                    $('iframe[src*="youtube.com"], iframe[src*="videopress.com"]').each(function() {
                        var url = $(this).attr("src")
                        $(this).wrap('<div class="video-container"/>');
                    }); 

                });



                /**
                 *
                 * Forms
                 *
                 */
                // Hide lables if placeholder browser support is available
                if ( ! ("placeholder" in document.createElement("input"))) {
                    //placeholder is supported, so hide your label elements or whatever
                    $('.gfield_label').addClass('show-label');
                }

                // Hide gravity forms validation errors on focus
                $('.gfield_error .ginput_container input').live('blur', function() {
                    if ( $(this).val() ) {
                        $(this).parent().parent().addClass('hide-error');
                    } else {
                        $(this).parent().parent().removeClass('hide-error');
                    }
                });



                /**
                 *
                 * Mobile Navigation
                 *
                 */
                var body, container, button, menu;

                body = document.getElementsByTagName('body')[0];
                container = document.getElementById('site-navigation');
                button = container.getElementsByTagName( 'button' )[0];
                menu = container.getElementsByTagName( 'div' )[0];
                
                button.onclick = function() {
                    if ( -1 !== body.className.indexOf( 'toggled' ) ) 
                    {
                        body.className = body.className.replace( ' toggled', '' );
                        // $("body").swipe('destroy');
                        // $(".site-header").headroom("init");
                    }
                    else 
                    {
                        body.className += ' toggled';
                        // $("body.toggled").swipe('enable');
                        // // Hide on swipe right
                        // $("body.toggled #page").swipe( {
                        //     //Generic swipe handler for all directions
                        //     swipeRight: function(event, direction, distance, duration, fingerCount, fingerData) {
                        //         body.className = body.className.replace( ' toggled', '' );
                        //     },
                        //     threshold: 50
                        // });
                        // $(".site-header").headroom('destroy');
                    }
                };

                // Mobile dropdown toggle
                $('ul.menu .toggle-menu').on('click', function(e) {
                    $(this).next('ul').toggleClass('open');
                });
                


                /**
                 *
                 * Old skip-link-focus-fix.js file (not sure what this does...accessibility??)
                 *
                 */
                var is_webkit = navigator.userAgent.toLowerCase().indexOf( 'webkit' ) > -1,
                    is_opera  = navigator.userAgent.toLowerCase().indexOf( 'opera' )  > -1,
                    is_ie     = navigator.userAgent.toLowerCase().indexOf( 'msie' )   > -1;

                if ( ( is_webkit || is_opera || is_ie ) && 'undefined' !== typeof( document.getElementById ) ) {
                    var eventMethod = ( window.addEventListener ) ? 'addEventListener' : 'attachEvent';
                    window[ eventMethod ]( 'hashchange', function() {
                        var element = document.getElementById( location.hash.substring( 1 ) );

                        if ( element ) {
                            if ( ! /^(?:a|select|input|button|textarea)$/i.test( element.tagName ) ) {
                                element.tabIndex = -1;
                            }

                            element.focus();
                        }
                    }, false );
                }



                /**
                 *
                 * SmoothScroll
                 *
                 */
                // $('a[href*="#"]:not([href="#"])').click(function() {
                //     if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
                //         var target = $(this.hash);
                //         target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                //         if (target.length) {
                //             $('html, body').animate({
                //                 scrollTop: target.offset().top - 80
                //             }, 1000);
                //             return false;
                //         }
                //     }
                // });



                /**
                 *
                 * Accordion
                 *
                 */
                $('.accordion').each(function(){
                    $(this).accordion({
                        speed: 400,
                        showFirst: false,
                        // item: '.panel',
                        // title: '.title',
                        // content: '.content'
                    });
                });



                /**
                 *
                 * Tabs
                 *
                 */
                $(document).ready(function() {
                    if ( $('#tabs').length ) {
                        new CBPFWTabs( document.getElementById( 'tabs' ) );
                    }
                });

                

                /**
                 *
                 * Slick slider
                 *
                 */
                $(document).ready(function() {
                    $('.content-slider').slick({
                        arrows: false,
                        dots: true
                    });
    
                    $('.fullwidth-slider').slick({
                        fade: true,
                        arrows: true,
                        dots: false,
                        prevArrow: $('.prev'),
                        nextArrow: $('.next')
                    });
                });


                /**
                 *
                 * AOS
                 *
                 */
                 AOS.init();



                 /**
                  *
                  * Healthcare Professional Gate
                  *
                  */
                $('.page-restrict-output button').on('click', function() {
                    var response = $(this).val();
                    if ( response === 'yes' ) {
                        // set cookie
                        document.cookie = "healthcare-professional=yes";
                        window.location.reload();
                    } else if ( response === 'no' ) {
                        window.history.back();
                    }
                    return false;
                });



                /**
                 *
                 * Hiring Process
                 *
                 */
                $('.process-list li .btn').on('click', function(e) {
                    e.preventDefault();
                    $('.process-list li').removeClass('active');
                    $(this).parent().toggleClass('active');
                });



                /**
                 *
                 * Announcement Bar
                 *
                 */
                function setCookie(cname, cvalue, exdays) {
                    var d = new Date();
                    d.setTime(d.getTime() + (exdays*24*60*60*1000));
                    var expires = "expires="+ d.toUTCString();
                    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
                }

                function getCookie(cname) {
                    var name = cname + "=";
                    var decodedCookie = decodeURIComponent(document.cookie);
                    var ca = decodedCookie.split(';');
                    for(var i = 0; i <ca.length; i++) {
                        var c = ca[i];
                        while (c.charAt(0) === ' ') {
                            c = c.substring(1);
                        }
                        if (c.indexOf(name) === 0) {
                            return c.substring(name.length, c.length);
                        }
                    }
                    return "";
                }

                $('.announcement-bar .close').on('click', function() {
                    $('.announcement-bar').slideUp(300);

                    setCookie('announcementOff', 'off', 365);
                });
                

            },
            finalize: function() {
                // JavaScript to be fired on all pages, after page specific JS is fired

            }
        },
        // Home page
        'home': {
            init: function() {
                // JavaScript to be fired on the home page

            },
            finalize: function() {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function() {
                // JavaScript to be fired on the about us page
            }
        },
        'management_team': {
            init: function() {
                // JavaScript to be fired on the about us page

                $('.bio-popup').magnificPopup();
            }
        },
        'manufacturing_facilities': {
            init: function() {
                // JavaScript to be fired on the about us page

                $('.details-popup').magnificPopup();
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function(func, funcname, args) {
            var fire;
            var namespace = Piramal;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function() {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
